import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Switch, withRouter} from 'react-router';
import PropTypes from 'prop-types';

import {setNavigationContext} from '../actions/navigation';

class RelativeSwitch extends Component {

    constructor(props) {
        super(props);
        const {location: {
                    pathname
                }, match: {
                    path
                }, name} = props,
            context = path.replace(/\/$/, '');
        this.state = {
            pathname: pathname.replace(context, '')
        };
        if (name) {
            this
                .props
                .setNavigationContext(name, context);
        }
    }

    componentWillReceiveProps({location: {
            pathname
        }, match: {
            path
        }, update}) {
        if (update !== false) {
            const context = path.replace(/\/$/, '');
            this.setState({
                pathname: pathname.replace(context, '')
            });
        }
    }

    shouldComponentUpdate(props, {pathname}) {
        return pathname !== this.state.pathname;
    }

    render() {
        const {children, location} = this.props, {pathname} = this.state,
            relativeLocation = {
                ...location,
                pathname
            };
        return <Switch location={relativeLocation}>{children}</Switch>;
    }
}

RelativeSwitch.propTypes = {
    location: PropTypes
        .shape({pathname: PropTypes.string.isRequired})
        .isRequired,
    match: PropTypes
        .shape({path: PropTypes.string.isRequired})
        .isRequired,
    name: PropTypes.string,
    update: PropTypes.bool
};

const ConnectedSwitch = connect(null, {setNavigationContext})(RelativeSwitch);
export default withRouter(ConnectedSwitch);


// WEBPACK FOOTER //
// ./src/containers/RelativeSwitch.js